import Vue from 'vue'
import router from '../router'
import axios from 'axios'
import Cookies from 'js-cookie'
import HttpError from './httpError'
import {Base64} from 'js-base64'
var url = ''
if (process.env.VUE_APP_ENV === 'test' || process.env.VUE_APP_ENV === 'production') {
  url = process.env.VUE_APP_API_URL
} 

const instance = axios.create({
  baseURL: url,
  timeout: 30000,
  crossDomain: true, //设置cross跨域
  withCredentials: true //设置cross跨域 并设置访问权限 允许跨域携带cookie信息
})

instance.interceptors.request.use(
  (config) => {
    let token = Cookies.get('pc_token') || ''
    // config.url = '/recruitment' + config.url
    config.headers = {
      'token': token,
      'version': process.env.VUE_APP_VERSION
    }
    return config
  },
  (error) => {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
)

// 响应拦截器
instance.interceptors.response.use(
  (config) => {
    if(config.data.code === "Error5201006"){
      return Promise.reject(config)
    }
    if (config.status !== 200) {
      Vue.prototype.$fail('网络错误！');
      return Promise.reject(config);
    } else {
      if(config.request.responseType === 'blob'){
        return config;
      }
      const status = HttpError(Vue, router, config)

      if (config.data.code !== '') {
        let run = status.get(config.data.code) || status.get('default')
        run()
        return Promise.reject(config)
      } else {
        return config.data
      }
    }
  },
  (error) => {
    // 对响应错误做点什么
    console.log(error)
    if(error.message.indexOf('Network Error') !==-1){
      Vue.prototype.$fail('网络连接异常，请检查网络后重试！')
    }
    if(error.message.indexOf("timeout") !==-1){
      Vue.prototype.$fail('请求超时，请检查网络或更换浏览器重试 !')
    }
    // Vue.prototype.$fail('系统错误！')
    return Promise.reject(error);
  }
);

instance.download = async (url, postedData = {}, otherOptions = {})=> {
	const { data, headers, code, reason } = await instance.post(url, postedData, {
		responseType: "blob",
		// ...otherOptions
	});
	if (!data) return;
	// console.log(headers)
	const fileName = decodeURI(headers["content-disposition"].split("filename=")[1]);
	const fileUrl = window.URL.createObjectURL(new Blob([data]));
	let link = document.createElement("a");

	link.style.display = "none";
	link.href = fileUrl;
	link.setAttribute("download", fileName);

	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
	window.URL.revokeObjectURL(fileUrl);
	try {
		
	} catch (error) {
		console.error("request exception -> error", error);
		return Promise.reject(error);
	}
}

export default instance
